// src/utils/cartSync.js
// ✅ Correct version
export const broadcastCartSync = () => {
    try {
      localStorage.setItem("requestCartSync", Date.now().toString());
    } catch (err) {
      console.warn("Failed to broadcast cart sync:", err);
    }
  };
  